import { ca } from '@cian/analytics';

export const trackFlatBannerShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Show_sopr',
    category: 'Сard',
    label: 'questionnaire_banner',
    useLastProducts: true,
  });
};
